if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                const loadingSpinner = this.querySelector('.loading__spinner');
                if (loadingSpinner) loadingSpinner.classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                const medalCustomization = document.querySelector('#medal-customization');
                const charmMetalCustomization = document.querySelector('#addon-toggle-metal');
                const charmSilverCustomization = document.querySelector('#addon-toggle-silver');
                const charmMessageCustomization = document.querySelector('#addon-toggle-message');
                let formCustomizationData = { items: [] };
                const hasCustomization =
                    (medalCustomization && medalCustomization.checked) ||
                    (charmMetalCustomization && charmMetalCustomization.checked) ||
                    (charmSilverCustomization && charmSilverCustomization.checked) ||
                    (charmMessageCustomization && charmMessageCustomization.checked);

                if (hasCustomization) {
                    const mainForm = document.querySelector('product-form');
                    const bundleId = mainForm.querySelector('#main-product-bundle-id')?.value || '';
                    const productQuantity = parseInt(document.querySelector('[name="quantity"]')?.value || '1', 10);

                    const customizationOptions = [
                        {
                            checkbox: medalCustomization,
                            inputSelector: '.medal-customization-text',
                            productId: 43418389479679
                        },
                        {
                            checkbox: charmMetalCustomization,
                            inputSelector: '#engraving-input-metal',
                            productId: 54524624765272
                        },
                        {
                            checkbox: charmSilverCustomization,
                            inputSelector: '#engraving-input-silver',
                            productId: 54546255610200
                        },
                        {
                            checkbox: charmMessageCustomization,
                            inputSelector: '#engraving-input-message',
                            productId: 54546780258648
                        }
                    ];

                    customizationOptions.forEach(option => {
                        if (option.checkbox && option.checkbox.checked) {
                            const inputElement = document.querySelector(option.inputSelector);
                            if (inputElement && inputElement.value !== '') {
                                formCustomizationData.items.push({
                                    id: option.productId,
                                    quantity: productQuantity,
                                    properties: { _bundle_id: bundleId }
                                });
                            }
                        }
                    });
                }

                setTimeout(() => {
                    fetch(`${routes.cart_add_url}`, config)
                        .then((response) => response.json())
                        .then((response) => {
                            if (response.status) {
                                publish(PUB_SUB_EVENTS.cartError, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    errors: response.errors || response.description,
                                    message: response.message,
                                });
                                this.handleErrorMessage(response.description);

                                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                                if (soldOutMessage) {
                                    this.submitButton.setAttribute('aria-disabled', 'true');
                                    this.submitButton.querySelector('span').classList.add('hidden');
                                    soldOutMessage.classList.remove('hidden');
                                    this.error = true;
                                }
                                return;
                            }

                            if (hasCustomization && formCustomizationData.items.length > 0) {
                                fetch(window.Shopify.routes.root + 'cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(formCustomizationData)
                                }).catch((error) => {
                                    console.error('Customization add error:', error);
                                });
                            }

                            if (!this.cart) {
                                window.location = window.routes.cart_url;
                                return;
                            }

                            if (!this.error)
                                publish(PUB_SUB_EVENTS.cartUpdate, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    cartData: response,
                                });
                            this.error = false;

                            const quickAddModal = this.closest('quick-add-modal');
                            if (quickAddModal) {
                                document.body.addEventListener('modalClosed', () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                }, { once: true });
                                quickAddModal.hide(true);
                            } else {
                                this.cart.renderContents(response);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {
                            this.submitButton.classList.remove('loading');
                            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                            const spinner = this.querySelector('.loading__spinner');
                            if (spinner) spinner.classList.add('hidden');
                        });
                }, 1500);
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}
